var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnIncontro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.633,
    height: 20.846,
    viewBox: "0 0 31.633 20.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-agreement",
    "data-name": "002-agreement",
    transform: "translate(0 -83.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 83.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.064,94.327a.626.626,0,0,0,.368.323l4.042,1.388a.576.576,0,0,0,.207.032.644.644,0,0,0,.607-.433l3.17-9.253.161.058a3.279,3.279,0,0,0,2.518-.142l.394-.194a1.981,1.981,0,0,1,1.511-.09l7.374,2.544a1.425,1.425,0,0,1-.484.794,1.523,1.523,0,0,1-1.356,0l-3.306-1.13a.64.64,0,0,0-.51.045.654.654,0,0,0-.316.4,4.4,4.4,0,0,1-1.9,2.492,4.137,4.137,0,0,1-3.358.045.641.641,0,0,0-.413,1.214,6.828,6.828,0,0,0,2.2.4,4.576,4.576,0,0,0,2.189-.536,5.381,5.381,0,0,0,2.292-2.641l2.712.93a2.7,2.7,0,0,0,2.5-.161,3.021,3.021,0,0,0,1.1-2.253.654.654,0,0,0-.433-.626l-7.878-2.718a3.274,3.274,0,0,0-2.492.155l-.394.194a2,2,0,0,1-1.53.09l-.652-.232a.428.428,0,0,0-.123-.058l-4.023-1.4a.64.64,0,0,0-.814.4L.032,93.843A.664.664,0,0,0,.064,94.327Zm4.365-9.35,2.828.969-2.97,8.672-2.828-.969Z",
    transform: "translate(0 -83.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M95.961,101.013a1.872,1.872,0,0,0,1.621,1.046,1.926,1.926,0,0,0,.187.82,1.842,1.842,0,0,0,1.078.949,1.833,1.833,0,0,0,1.427-.09l.336-.168a1.937,1.937,0,0,0,.174.581,1.842,1.842,0,0,0,1.078.949,1.833,1.833,0,0,0,1.427-.09l7.342-3.6a18.9,18.9,0,0,0,4.494-3.067l1.64-1.5,3.752-1.834a.636.636,0,0,0,.291-.852l-4.572-9.382a.641.641,0,0,0-.859-.291l-3.835,1.879a.636.636,0,0,0-.291.852l4.378,8.949-1.356,1.246a17.837,17.837,0,0,1-4.191,2.86l-7.342,3.6a.593.593,0,0,1-.458.026.608.608,0,0,1-.342-.3.593.593,0,0,1-.026-.458.608.608,0,0,1,.3-.342l4.107-2.008a.637.637,0,0,0-.562-1.143l-4.107,2.008h0l-1.937.949a.593.593,0,0,1-.458.026.608.608,0,0,1-.342-.3.593.593,0,0,1-.026-.458.608.608,0,0,1,.3-.342l5.889-2.88a.637.637,0,1,0-.562-1.143L97.9,100.729a.607.607,0,0,1-.8-.271.593.593,0,0,1-.026-.458.608.608,0,0,1,.3-.342l2.609-1.278h0l3.39-1.659a.637.637,0,0,0-.562-1.143l-5.275,2.583a.6.6,0,0,1-.529-1.072l2.8-1.369a.637.637,0,0,0-.562-1.143l-2.8,1.369a1.877,1.877,0,0,0-.329,3.164A1.846,1.846,0,0,0,95.961,101.013Zm16.717-13.786,2.686-1.317,4.029,8.233-2.686,1.317Z",
    transform: "translate(-89.24 -84.357)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnIncontro);
export default __webpack_public_path__ + "static/media/icn-incontro.63bf8917.svg";
export { ForwardRef as ReactComponent };